import { useMediaQuery, useTheme } from '@mui/material'
import { themeV2 } from '@valerahealth/ui-components/theme/theme'

export function useGetScreenSize() {

  const isMdUp = useMediaQuery('(min-width:1100px)')
  const isXsUp = useMediaQuery(themeV2.breakpoints.up('sm'))
  const size = isMdUp ? 2 : isXsUp ? 1 : 0
  const isMobile = size === 0
  return { isMdUp, isXsUp, size, isMobile }
}

export {detectMobileBrowser} from '@valerahealth/ui-components/utils/detectmobilebrowser'